module.exports = __webpack_public_path__ + "static/pic01-65b049d1c2fdd963cfca36f08789d3e9.jpg";